export default "__VITE_ASSET__d95f7849__"